import { render, staticRenderFns } from "./TopChannels.vue?vue&type=template&id=51450958&"
import script from "./TopChannels.vue?vue&type=script&lang=js&"
export * from "./TopChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports